import { useEffect, useState } from 'react';

// material-ui
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

// project import
import NavGroup from './NavGroup';
import menuItem from 'menu-items';

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================= //

export default function Navigation() {
  const [sessionVersion, setSessionVersion] = useState(0);

  useEffect(() => {
    const refreshSidebar = () => setSessionVersion((version) => version + 1);
    window.addEventListener('adminSessionUpdated', refreshSidebar);
    return () => window.removeEventListener('adminSessionUpdated', refreshSidebar);
  }, []);

  const navGroups = menuItem.items.map((item) => {
    switch (item.type) {
      case 'group':
        return <NavGroup key={`${item.id}-${sessionVersion}`} item={item} />;
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });

  return <Box sx={{ pt: 2 }}>{navGroups}</Box>;
}
